import * as types from '../actions/actionTypes';
import initialState from './initialState';


export default function userReducer(state = initialState.users, action) {
    switch (action.type) {
        case types.LOAD_USERS_SUCCESS:
            return action.users;
        case types.DETACH_COMPANY_SUCCESS:
            let users = {...state};
            return users.map(user => {
                if(action.userIds.indexOf(user.id) !== -1) {
                    user.company = null;
                }

                return user;
            });

            break;
        case types.CREATE_USER_SUCCESS:
            return [...state, ...action.user];
        case types.DELETE_USER_SUCCESS:
            const data = state.data.filter(user => user.id !== action.id);
            return {...state, ...{data}, ...{total: state.total - 1}};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/usersReducer.js